import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Requirement from "./Requirement";
import GridConfig from "../GridConfig";
import RequirementPricingReport from "./RequirementPricingReport";

export default class Requirements extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            solutionId: props.SolutionId,
            controllerName: 'solution/requirement',
            data: null,
            loading: true,
            configName: 'solution_requirement_grid',
            moduleName: 'نیازمندی ها'
        };
        this.state.filters = {
            solutionId: this.state.solutionId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Requirement Caller={this} Id={id} SolutionId={this.state.solutionId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Requirement Caller={this} SolutionId={this.state.solutionId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "itemName", caption: "عنوان", show: true },
                { field: "description", caption: "توضیحات", show: true },
                { field: "itemCount", caption: "تعداد", show: true },
                { field: "unitName", caption: "واحد", show: true },
                { field: "firstPrice", caption: "برآورد اولیه", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: false },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    ShowRequirementPricing(requirementId) {
        this.removeKeyDown();
        this.showComponents({ component: <RequirementPricingReport Caller={this} RequirementId={requirementId} /> });
    }
    
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'itemName' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.itemName}</a> } });
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'itemCount' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'unitName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'firstPrice' && f.show) t.push({ field: f.field, headerName: f.caption ,cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.firstPrice) } });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a onClick={e => this.ShowRequirementPricing(props.data.id)} className="hand text-warning">
                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> برآوردها</span>
                    </a>
                ]
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">نیازمندی ها</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(true, { add: true, print: true, pdf: true, excell: true, remove: true, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}